import { SnackbarProvider as NotistackProvider, SnackbarKey, closeSnackbar } from 'notistack';
import { useRef } from 'react';
// @mui
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
//
import { Iconify } from '../iconify';
//
import { StyledIcon, StyledNotistack } from './styles';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

type ActionProps = {
  snackbarId: SnackbarKey;
};

const Action = ({ snackbarId }: ActionProps) => (
  <IconButton size="small" onClick={() => closeSnackbar(snackbarId)} sx={{ p: 0.5 }}>
    <Iconify width={16} icon="mingcute:close-line" />
  </IconButton>
);

export default function SnackbarProvider(props: Props) {
  const isRTL = true;

  const notistackRef = useRef<any>(null);
  const { children } = props;
  const renderAction = (snackbarId: SnackbarKey) => <Action snackbarId={snackbarId} />;

  return (
    <NotistackProvider
      ref={notistackRef}
      maxSnack={5}
      preventDuplicate
      autoHideDuration={3000}
      TransitionComponent={isRTL ? Collapse : undefined}
      variant="success" // Set default variant
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      iconVariant={{
        info: (
          <StyledIcon color="info">
            <Iconify icon="eva:info-fill" width={24} />
          </StyledIcon>
        ),
        success: (
          <StyledIcon color="success">
            <Iconify icon="eva:checkmark-circle-2-fill" width={24} />
          </StyledIcon>
        ),
        warning: (
          <StyledIcon color="warning">
            <Iconify icon="eva:alert-triangle-fill" width={24} />
          </StyledIcon>
        ),
        error: (
          <StyledIcon color="error">
            <Iconify icon="solar:danger-bold" width={24} />
          </StyledIcon>
        ),
      }}
      Components={{
        default: StyledNotistack,
        info: StyledNotistack,
        success: StyledNotistack,
        warning: StyledNotistack,
        error: StyledNotistack,
      }}
      // with close as default
      action={renderAction}
    >
      {children}
    </NotistackProvider>
  );
}
